import isObject from './isObject';

// ----------------------------------------------------------------------------

function isObjectFor(...args: any): boolean {
    for (const item of args) {
        if (!isObject(item)) {
            return false;
        }
    }

    return true;
}

// ----------------------------------------------------------------------------

export default isObjectFor;
